import React from 'react';
import FormItemDescription from './FormItemDescription';
import { isFormMultiplesField } from '../state/state';
import FormStringsDescriptionWrapper from './FormStringsDescriptionWrapper';

const FormListDescription = ({
  canEdit,
  field,
  showEdit,
  text,
}) => {
  if (!isFormMultiplesField(field.validation)) {
    return (<FormItemDescription canEdit={canEdit} field={field} showEdit={showEdit} text={text} />);
  }
  return (<FormStringsDescriptionWrapper canEdit={canEdit} showEdit={showEdit} options={field.options} text={text} />);
};

export default FormListDescription;
